"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relsXml = void 0;
exports.relsXml = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"yes\"?>\n<Relationships xmlns=\"http://schemas.openxmlformats.org/package/2006/relationships\">\n  <Relationship\n      Type=\"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument\"\n      Target=\"/word/document.xml\" Id=\"R09c83fafc067488e\" />\n</Relationships>\n";
